// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DOCS = '/docs';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};


export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    maindashboard: path(ROOTS_DASHBOARD, '/maindashboard'),
    customermanagement: path(ROOTS_DASHBOARD, '/customermanagement'),
    activitylog: path(ROOTS_DASHBOARD, '/activitylog')
  },
  pointofsale: {
    root: path(ROOTS_DASHBOARD, '/pointofsale'),
    customerlookup: path(ROOTS_DASHBOARD, '/pointofsale/customerlookup'),
    allorders: path(ROOTS_DASHBOARD, '/pointofsale/allorders'),
    reversetaxcalculator: path(ROOTS_DASHBOARD, '/pointofsale/reversetaxcalculator'),
    printersettings: path(ROOTS_DASHBOARD, '/pointofsale/printersettings'),
    poscart: path(ROOTS_DASHBOARD, '/pointofsale/poscart'),
    placeorder: path(ROOTS_DASHBOARD, '/pointofsale/placeorder'),
  },
  expenses: {
    root: path(ROOTS_DASHBOARD, '/expenses'),
    allexpenses: path(ROOTS_DASHBOARD, '/expenses/allexpenses'),
    expensetype: path(ROOTS_DASHBOARD, '/expenses/expensetype')
  },
  inventory: {
    root: path(ROOTS_DASHBOARD, '/inventory'),
    inventorylist: path(ROOTS_DASHBOARD, '/inventory/inventorylist'),
    inventoryaudit: path(ROOTS_DASHBOARD, '/inventory/inventoryaudit'),
    categorytype: path(ROOTS_DASHBOARD, '/inventory/categorytype'),
    datavariable: path(ROOTS_DASHBOARD, '/inventory/datavariable'),
    productcategory: path(ROOTS_DASHBOARD, '/inventory/productcategory'),
    taxcategory: path(ROOTS_DASHBOARD, '/inventory/taxcategory'),
    printbarcode: path(ROOTS_DASHBOARD, '/inventory/printbarcode'),
    alloutgoingtransfers: path(ROOTS_DASHBOARD, '/inventory/alloutgoingtransfers'),
    allincomingtransfers: path(ROOTS_DASHBOARD, '/inventory/allincomingtransfers'),
    heldtransferorders: path(ROOTS_DASHBOARD, '/inventory/heldtransferorders'),
    transfers: path(ROOTS_DASHBOARD, '/inventory/transfers'),
  },
  purchase: {
    root: path(ROOTS_DASHBOARD, '/purchase'),
    allsuppliers: path(ROOTS_DASHBOARD, '/purchase/allsuppliers'),
    allsuppliertypes: path(ROOTS_DASHBOARD, '/purchase/allsuppliertypes'),
    receiveinventoryorders: path(ROOTS_DASHBOARD, '/purchase/receiveinventoryorders')
  },
  staffmanagement: {
    root: path(ROOTS_DASHBOARD, '/staffmanagement'),
    staffdirectory: path(ROOTS_DASHBOARD, '/staffmanagement/staffdirectory'),
    userroles: path(ROOTS_DASHBOARD, '/staffmanagement/userroles'),
    staffscheduler: path(ROOTS_DASHBOARD, '/staffmanagement/staffscheduler'),
    stafftimetracking: path(ROOTS_DASHBOARD, '/staffmanagement/stafftimetracking'),
  },
  reports: {
    root: path(ROOTS_DASHBOARD, '/reports'),
    profitloss: path(ROOTS_DASHBOARD, '/reports/profitloss'),
    customers: path(ROOTS_DASHBOARD, '/reports/customers'),
    staffs: path(ROOTS_DASHBOARD, '/reports/staffs'),
    expenses: path(ROOTS_DASHBOARD, '/reports/expenses'),
    products: path(ROOTS_DASHBOARD, '/reports/products'),
    receiveinventory: path(ROOTS_DASHBOARD, '/reports/receiveinventory'),
    sales: path(ROOTS_DASHBOARD, '/reports/sales'),
    _salesbyfilter: path(ROOTS_DASHBOARD, '/reports/_salesbyfilter'),
    refundedsales: path(ROOTS_DASHBOARD, '/reports/refundedsales'),
    _salesbycategory: path(ROOTS_DASHBOARD, '/reports/_salesbycategory'),
    _salescounts: path(ROOTS_DASHBOARD, '/reports/_salescounts'),
    _salescountbyhour: path(ROOTS_DASHBOARD, '/reports/_salescountbyhour'),
    _salescountbyday: path(ROOTS_DASHBOARD, '/reports/_salescountbyday'),
    __salescountbydayandhour: path(ROOTS_DASHBOARD, '/reports/__salescountbydayandhour'),
    bestseller: path(ROOTS_DASHBOARD, '/reports/bestseller'),
    _bestsellersbyquantity: path(ROOTS_DASHBOARD, '/reports/_bestsellersbyquantity'),
    worstsellers: path(ROOTS_DASHBOARD, '/reports/worstsellers'),
    _worstsellersbyquantity: path(ROOTS_DASHBOARD, '/reports/_worstsellersbyquantity'),
    _payments: path(ROOTS_DASHBOARD, '/reports/_payments'),
    _customerpendingpayments: path(ROOTS_DASHBOARD, '/reports/_customerpendingpayments'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
};

export const PATH_DOCS = {
  root: ROOTS_DOCS,
  introduction: path(ROOTS_DOCS, '/introduction'),
  quickstart: path(ROOTS_DOCS, '/quick-start'),
  package: path(ROOTS_DOCS, '/package'),

  // Theme UI
  color: path(ROOTS_DOCS, '/color'),
  typography: path(ROOTS_DOCS, '/typography'),
  icon: path(ROOTS_DOCS, '/icon'),
  shadows: path(ROOTS_DOCS, '/shadows'),
  components: path(ROOTS_DOCS, '/components'),
  settings: path(ROOTS_DOCS, '/settings'),
  tips: path(ROOTS_DOCS, '/tips'),

  // Development
  routing: path(ROOTS_DOCS, '/routing'),
  environmentVariables: path(ROOTS_DOCS, '/environment-variables'),
  stateManagement: path(ROOTS_DOCS, '/state-management'),
  apiCalls: path(ROOTS_DOCS, '/api-calls'),
  analytics: path(ROOTS_DOCS, '/analytics'),
  authentication: path(ROOTS_DOCS, '/authentication'),
  multiLanguage: path(ROOTS_DOCS, '/multi-language'),
  lazyload: path(ROOTS_DOCS, '/lazyload-image'),
  formHelper: path(ROOTS_DOCS, '/form-helper'),

  // Changelog
  support: path(ROOTS_DOCS, '/support'),
  changelog: path(ROOTS_DOCS, '/changelog')
};